import { observer } from 'mobx-react'
import { useStores } from '~/hooks/useStores'
import { AnalyticsScript } from '~/components/business/AnalyticsScript'
import { ReactNode } from 'react'
import { LoginModal } from '~/components/pages/login/LoginModal'

export const Layout: React.FC<{
  children?: ReactNode
  className?: string
  style?: React.CSSProperties
}> = observer(({ children, className, style }) => {
  const { store } = useStores()

  const loginVisible = !!store.modal?.login

  const isProd = process.env.NEXT_PUBLIC_NODE_ENV === 'production'

  return (
    <div className={className} style={style}>
      {children}
      {loginVisible && <LoginModal />}
      {isProd && <AnalyticsScript />}
    </div>
  )
})
